import { render } from "./PoolsPanel.vue?vue&type=template&id=2ba637f4&scoped=true"
import script from "./PoolsPanel.vue?vue&type=script&lang=js"
export * from "./PoolsPanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/submissionsPanel.scss?vue&type=style&index=0&id=2ba637f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba637f4"]])

export default __exports__